<template lang="html">
  <div class="order-list-warpper">
    <ul class="column-list">
      <li v-for="(item, index) in columnData.columns" :key="item.newId">
        <div
          :class="{ active: type === item.newId }"
          class="pf-medium"
          @click="changeTab(item.newId, index)"
          :id="`column${item.newId}`"
        >
          <p class="column-list-title">{{ item.title }}</p>
          <span></span>
        </div>
      </li>
    </ul>
    <div class="banner" v-if="newBanner && newBanner.length > 0 && !isCzjApp">
      <swipe :auto="3000">
        <swipe-item v-for="(item, index) in newBanner" :key="index">
          <a :href="item.link">
            <img v-lazy="$$viewImage(item.image, 750, 250)" />
          </a>
        </swipe-item>
      </swipe>
    </div>
    <loadData
      viewName="orderList"
      :fetchData="list"
      :fetchMethod="getOrderList"
      :controlPage="changePage"
      :page="page"
      :pageSize="pageSize"
      :firstFetch="firstFetch"
      :hasErr="hasErr"
      :otherParams="{
        errText: '暂无相关订单信息',
        errorClass: 'kwstatus-fail-order'
      }"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Swipe, SwipeItem } from 'mint-ui'
import loadData from '@/components/loadMore'
import BUS from '../../Bus/order.js'
import { pageReloadInIOS12 } from '@/utils'
import { pageReloadInStatusChange } from '@/utils/order/orderEvent'

export default {
  inject: ['reload'],
  data() {
    return {
      type: 0,
      uid: '',
      skey: '',
      tabIndex: 0,
      columnId: 0,
      page: 1,
      pageSize: 10,
      list: [],
      banner: [],
      firstFetch: true,
      hasErr: false,
      img: require('../../assets/images/empty1.png')
    }
  },
  async created() {
    pageReloadInIOS12()
    pageReloadInStatusChange()

    BUS.ON_E_DEL_ITEM_BY_PASSED_INDEX(i => {
      this.list.splice(i, 1)
    })

    try {
      this.$$loading(true)
      const { uid, skey } = await this.$$ensureLogin()
      this.uid = uid
      this.skey = skey
      await this.$store.dispatch('getColumnData')
      this.$$title(this.columnData.title || '育儿顾问服务订单')
      this.type =
        this.$route.query.type || this.columnData.columns[0].newId || ''
      this.columnId = this.type || this.columnData.columns[0].newId || ''
      if (!this.$$isMp()) {
        // 小程序中不显示banner
        this.banner = this.columnData.columns[this.columnId]
          ? this.columnData.columns[this.columnId].banner || []
          : []
      }
      await this.getOrderList()
      this.$$loading(false)
    } catch (e) {
      console.log(e)
    } finally {
      this.$$loading(false)
    }
  },
  mounted() {
    this.$$allowRefreshOrShare(true, false)
    this.$$newTrackView({
      bizType: '127',
      pageLevelId: '121013097'
    })
  },
  computed: {
    ...mapState(['columnData']),
    newBanner() {
      return this.banner.filter(ele => ele.image !== '')
    },
    isCzjApp() {
      return this.$$isCZJApp()
    }
  },
  methods: {
    changeTab(id, index) {
      this.$$newTrackClick({
        bizType: '127',
        pageLevelId: '121013097',
        clickId: '200001'
      })
      if (index !== this.tabIndex || id !== this.columnId) {
        // this.tabIndex = index
        // this.columnId = id
        // this.banner = this.columnData.columns[this.columnId] ? this.columnData.columns[this.columnId].banner || [] : []
        // this.page = 1
        // this.firstFetch = true
        // this.getOrderList()
        this.$router.replace(`/user/order?type=${id}&cmd=share&sharetype=0`)
        this.reload()
      }
    },
    async getOrderList() {
      try {
        if (this.page === 1) {
          this.list.length = 0
          this.list = []
        }
        const orderlist = await this.$store.dispatch(
          'getOrderListWithPageAndState',
          {
            uid: this.uid,
            skey: this.skey,
            status: this.columnId,
            page_size: this.pageSize,
            page_num: this.page
          }
        )
        this.list.push(...(orderlist || []))
        this.firstFetch = false
      } catch (e) {
        console.log(e)
        if (e.message === '4') {
          this.$$login()
        } else {
          this.firstFetch = false
          // this.$$toast('网络异常，请刷新重试')
          this.hasErr = true
        }
      }
    },
    changePage(page) {
      this.page = page
    }
  },
  components: {
    Swipe,
    SwipeItem,
    loadData
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.order-list-warpper {
  min-height: 100%;
  background-color: #f4f4f4;
  position: relative;
  padding-top: rem(98px);

  .column-list {
    // @include border(bottom);
    left: 0;
    top: 0;
    width: 100%;
    height: rem(98px);
    background-color: #fff;
    display: flex;
    align-items: left;
    justify-content: left;
    margin-bottom: rem(20px);
    position: fixed;
    z-index: 199;

    li {
      height: rem(98px);
      width: rem(150px);
      font-size: rem(28px);
      text-align: center;
      .column-list-title {
        font-size: rem(26px);
        color: #262626;
        text-align: center;
        line-height: rem(32px);
        padding-top: rem(30px);
        padding-bottom: rem(4px);
      }

      .active {
        .column-list-title {
          color: #ff5900;
          //   font-weight: 500;
        }
        span {
          &::after {
            margin-top: rem(4px);
            display: block;
            content: ' ';
            color: #ff5900;
            background-image: linear-gradient(90deg, #ff5900 0%, #ff8800 100%);
            width: rem(45px);
            height: rem(5px);
            border-radius: rem(2.5px);
            margin-left: rem(53px);
          }
        }
      }
    }
  }
  .banner {
    background-color: #fff;
    height: rem(250px);
    margin-top: rem(20px);

    img {
      display: block;
      width: 100%;
      height: rem(250px);
    }
  }
}
</style>
<style lang="scss">
@import '../../assets/css/mixin';
#dialog_content {
  // display: none;
}
.dialog-useCode {
  color: #121212;
  font-size: rem(28px);
  line-height: 1.5;

  .summary {
    text-align: left;
    margin-top: rem(30px);
  }
  .item-cell {
    margin: rem(25px) 0;
  }
  .item-cell-bd {
    white-space: nowrap;
  }
  input {
    margin-left: rem(20px);
    border-bottom: 1px solid #eee;
  }
}
</style>
